import { Component, input, OnDestroy, OnInit } from "@angular/core";
import { Router, RouterLink } from "@angular/router";

import { TopLevelFilteringOptionsComponent } from "@shared/top-level-filtering-options/top-level-filtering-options.component";

import { BasicFiltersComponent } from "../basic-filters/basic-filters.component";
import { FactSheetPlantGuideSearchComponent } from "../factsheet-plantguide-search/factsheet-plantguide-search.component";
import { GlobalSearchComponent } from "../global-search/global-search.component";

@Component({
  selector: "sidebar-menu",
  imports: [
    RouterLink,
    BasicFiltersComponent,
    FactSheetPlantGuideSearchComponent,
    GlobalSearchComponent,
    TopLevelFilteringOptionsComponent
  ],
  templateUrl: "./sidebar-menu.component.html",
  styleUrl: "./sidebar-menu.component.scss"
})
export class SidebarMenuComponent implements OnInit, OnDestroy {
  // todo: add debounce
  readonly USWDS_TABLET = "(min-width: 640px)";
  isShowingSearchResults = input.required<boolean>();
  isTablet = false;
  mediaQuery: MediaQueryList | null = null;

  constructor(public router: Router) {}
  ngOnInit() {
    this.mediaQuery = window.matchMedia(this.USWDS_TABLET);
    this.isTablet = this.mediaQuery.matches;
    this.mediaQuery.addEventListener("change", this.onMediaQueryChange);
  }

  ngOnDestroy() {
    if (this.mediaQuery) {
      this.mediaQuery.removeEventListener("change", this.onMediaQueryChange);
    }
  }

  onMediaQueryChange(event: MediaQueryListEvent): void {
    this.isTablet = event.matches;
  }
}
